import { render, staticRenderFns } from "./CorrelationLinker.vue?vue&type=template&id=6f2db619&scoped=true"
import script from "./CorrelationLinker.vue?vue&type=script&lang=js"
export * from "./CorrelationLinker.vue?vue&type=script&lang=js"
import style0 from "./CorrelationLinker.vue?vue&type=style&index=0&id=6f2db619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2db619",
  null
  
)

export default component.exports